import React from 'react';
import { hasSpeechToText } from 'lib/utilities';

class SpeechToText extends React.Component {

    constructor(props) {
        super(props);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.state = {
            isTranscribing: false,
            error: null
        };
    }

    start() {
        if (!hasSpeechToText()) {
            this.setState({ error: 'Speech recognition not available' });
            return;
        }

        this.setState({ isTranscribing: true, error: null });

        window.plugins.speechToText.startTranscribing(
            (finalText) => {
                // Final result
                if (this.props.textUpdateHandler) {
                    this.props.textUpdateHandler(finalText);
                }
                this.setState({ isTranscribing: false });
            },
            (error) => {
                // Error callback
                this.setState({ error, isTranscribing: false });
            },
            {
                textUpdateHandler: (partialText) => {
                    // Partial updates
                    if (this.props.textUpdateHandler) {
                        this.props.textUpdateHandler(partialText);
                    }
                }
            }
        );
    }

    stop() {
        if (!hasSpeechToText()) {
            return;
        }

        window.plugins.speechToText.stopTranscribing(
            () => {
                this.setState({ isTranscribing: false });
            },
            (error) => {
                this.setState({ error });
            }
        );
    }

    render() {
        return this.props.render({
            start: this.start,
            stop: this.stop,
            isTranscribing: this.state.isTranscribing,
            error: this.state.error
        });
    }
}

export default SpeechToText;
